import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/session/assignformat.module.scss";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import {
  getFormatSessionById,
  getSessionById,
  getSessionFormatCategory,
  updateSessionFormatCategory,
} from "../../services";
import ReactQuill from "react-quill";
import { useSelector } from "react-redux";
import {
  dispatch,
  saveSessionDetails,
  saveSubmittedData,
  toggle,
} from "../../redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function secondsToHhmmss(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, "0"))
    .join(":");
}
function hhmmssToSeconds(time) {
  const [hours, minutes, seconds] = time.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

const EditFormat = () => {
  const { formatId } = useParams();
  const { formatCategories, sessionDetails, formats: submittedData } = useSelector(
    (state) => state.sessionFormats
  );
  const { sessionFormat } = useSelector((state) => state.sessionFormats);
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const navigate = useNavigate();
  const [restPeriods, setRestPeriods] = useState("");

  const [format, setSelectedFormat] = useState("");
  const [subFormat, setSelectedSubFormat] = useState("");
  const [restPeriodDetails, setRestPeriodDetails] = useState("");
  const hoursRef = useRef(null);
  const minutesRef = useRef(null);
  const secondsRef = useRef(null);
  const [hours, setHours] = useState("");
  const [minutes, setMinutes] = useState("");
  const [seconds, setSeconds] = useState("");
  const [sesssionDetails, setSessionDetails] = useState();
  const [showEditModal, setShowEditModal] = useState(false);
  const [showEditSubModal, setShowEditSubModal] = useState(false);
  const [editableFormats, setEditableFormats] = useState([]);
  const [editableSubFormats, setEditableSubFormats] = useState([]);

  const sessionId = sessionFormat?.session;

  
  useEffect(() => {
    return () => sessionStorage.removeItem("hasRefreshed"); // Reset on unmount
  }, []);
  
  useEffect(() => {
    const fetchSession = async () => {
      try {
        const response = await getSessionById(sessionId);

        if (response) {
          const details = {
            sessionId: response._id,
            name: response.name,
            code: response.code,
            details: response.details,
            thankyou: response.thankyou,
          };

          setSessionDetails(details);
          dispatch(saveSessionDetails(details));
        }
      } catch (error) {
        console.error("Error fetching session details:", error);
      }
    };
    setSessionDetails(null);
    if (sessionId) {
      fetchSession();
    }
  }, [sessionId]);

  useEffect(() => {
    if (formatId) {
      
      if (!sessionFormat || Object.keys(sessionFormat).length === 0) {
        getFormatSessionById(formatId);
      }

      getSessionFormatCategory();
    }
  }, [formatId]);

  useEffect(() => {
    // If submittedData exists (user came back from next page), use that instead
    if (submittedData && Object.keys(submittedData).length > 0) {
      setRestPeriods(secondsToHhmmss(submittedData.restPeriods || ""));
      setSelectedFormat(submittedData.format || "");
      setSelectedSubFormat(submittedData.subFormat || "");
      setRestPeriodDetails(submittedData.restPeriodDetails || "");

      if (submittedData.restPeriods) {
        const [hrs, mins, secs] = secondsToHhmmss(submittedData.restPeriods).split(
          ":"
        );

        setHours(hrs);
        setMinutes(mins);
        setSeconds(secs);
      }
    } else if (sessionFormat) {
      // Otherwise, use sessionFormat from API
      setRestPeriods(secondsToHhmmss(sessionFormat.restTime || ""));
      setSelectedFormat(sessionFormat.format?.name || "");
      setSelectedSubFormat(sessionFormat.subFormat || "");
      setRestPeriodDetails(sessionFormat.restPeriodDetails || "");

      if (sessionFormat.restTime) {
        const [hrs, mins, secs] = secondsToHhmmss(sessionFormat.restTime).split(
          ":"
        );

        setHours(hrs);
        setMinutes(mins);
        setSeconds(secs);
      }
    }
  }, [sessionFormat, submittedData]);

  useEffect(() => {
    if (!sessionDetails) {
      navigate(adminRoutes.listSession);
    }
  }, [sessionDetails, navigate]);
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  const handleFormatChange = (event) => {
    const selectedFormat = event.target.value;
    if (selectedFormat === "update-list") {
      setEditableFormats(formatCategories.map(item => ({ ...item })));
      setShowEditModal(true);
      setSelectedFormat("");
    } else {
      setSelectedFormat(selectedFormat);
      setSelectedSubFormat("");
    }
  };

  const handleSubFormatChange = (event) => {
    const selectedSub = event.target.value;
    if (selectedSub === "update-list") {
      if (!format) {
        toast.error("Please select a Format first");
        return;
      }
      const currentFormatObj = formatCategories.find(item => item.name === format);
      if (currentFormatObj) {
        setEditableSubFormats([...currentFormatObj.subFormats]);
        setShowEditSubModal(true);
      }
      setSelectedSubFormat("");
    } else {
      setSelectedSubFormat(selectedSub);
    }
  };

  const handleEditFormatSave = async () => {
    try {
      const promises = editableFormats.map(item => 
        updateSessionFormatCategory(item._id, { name: item.name })
      );
      await Promise.all(promises);
      getSessionFormatCategory();
      setShowEditModal(false);
    } catch (error) {
      toast.error("Failed to update formats");
    }
  };

  const handleEditSubFormatSave = async () => {
    try {
      const currentFormatObj = formatCategories.find(item => item.name === format);
      if (!currentFormatObj) return;

      const response = await updateSessionFormatCategory(currentFormatObj._id, { subFormats: editableSubFormats });
      if (response) {
        getSessionFormatCategory();
        setShowEditSubModal(false);
      }
    } catch (error) {
      toast.error("Failed to update sub-formats");
    }
  };

  const handleTimeFieldChange = (e, field) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 2) value = value.slice(-2);
    
    if (field === "hours") {
      if (parseInt(value, 10) > 24) value = "24";
    }

    if (field === "minutes" || field === "seconds") {
      if (parseInt(value, 10) > 59) value = "59";
    }

    if (field === "hours") setHours(value);
    if (field === "minutes") setMinutes(value);
    if (field === "seconds") setSeconds(value);
  };

  const padTimeValue = (value, setter) => {
    if (value) {
      setter(value.padStart(2, "0"));
    } else {
      setter("00");
    }
  };

  useEffect(() => {
    const h = parseInt(hours || "0", 10);
    const m = parseInt(minutes || "0", 10);
    const s = parseInt(seconds || "0", 10);
    setRestPeriods(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`);
  }, [hours, minutes, seconds]);



  const handleRestPeriodDetailsChange = (value) => {
    setRestPeriodDetails(value);
  };

  const handleSubmit = async () => {
    const formData = {
      sessionId,
      formatId: formatCategories.find(
        (formatItem) => formatItem.name === format
      )?._id,
      format,
      subFormat,
      restPeriods: hhmmssToSeconds(restPeriods),
      sessionDetails,
      restPeriodDetails,
    };

    dispatch(saveSubmittedData(formData));
    navigate(adminRoutes.editAssignFormatSecond.replace(":formatId", formatId));
  };

  const handleBack = async () => {
    navigate(adminRoutes.listFormat.replace(":sessionId", sessionFormat.session));
    setTimeout(() => window.location.reload(), 100);
  };
  

  return (
    <>
      <ToastContainer />

      <Navbar />
      <div
        className={Styles.assign_list_container}
        onClick={handleMainContainerClick}
      >
        {" "}
        <h2>
          <Link to={adminRoutes.listSession}>HOME / </Link>{" "}
          <span> CREATE NEW FORMAT</span>
        </h2>
        <div className={Styles.table_container_main}>
          <div className={Styles.table_container}>
            <div className={Styles.table_container_heading}>
              <div className={Styles.table_container_headingone}>
                <h3>CREATE NEW FORMAT</h3>
              </div>
              <div className={Styles.table_container_headingtwo}>
                <div className={Styles.create_new_assign}>
                  <h6>Session Name</h6>
                  <p>{sessionDetails.name}</p>
                </div>
              </div>
            </div>
            <div className={Styles.seperator}>
              <hr className={Styles.line} />
            </div>
          </div>
          <div className={Styles.progress_indicator}>
            <div className={Styles.progress_line}>
              <div className={`${Styles.step} ${Styles.active}`}>
                <div className={Styles.circle}></div>
              </div>
              <div className={`${Styles.line} ${Styles.active}`}></div>

              <div className={`${Styles.step} ${Styles.inactive}`}>
                <div className={Styles.circle}></div>
              </div>
              <div className={`${Styles.line} ${Styles.inactive}`}></div>

              <div className={`${Styles.step} ${Styles.inactive}`}>
                <div className={Styles.circle}></div>
              </div>
            </div>
            <div className={Styles.label}>Enter Details</div>
          </div>

          <div className={Styles.assign_format_container}>
            <div className={Styles.createsession_form}>
              <div className={Styles.createsession_form_containerone}>
                <div>
                  <label className={Styles.label}>Format</label>
                    <select onChange={handleFormatChange} value={format} className={Styles.dropdown_select}>
                      <option value="" disabled selected>
                        Choose from list
                      </option>
                      {[
                        ...new Set(
                          formatCategories.map((formatItem) => formatItem.name)
                        ),
                      ].map((uniqueFormat, index) => (
                        <option key={index} value={uniqueFormat}>
                          {uniqueFormat}
                        </option>
                      ))}
                      <option value="update-list" style={{ color: "#f79328", fontWeight: "bold" }}>
                        Update List
                      </option>
                    </select>
                </div>
              </div>

              <div className={Styles.createsession_form_containertwo}>
                <div>
                  <label className={Styles.label}>Sub-Format</label>
                  <select onChange={handleSubFormatChange} value={subFormat} className={Styles.dropdown_select}>
                    <option value="" disabled selected>
                      Choose a sub-format
                    </option>{" "}
                    {formatCategories
                      .find((formatItem) => formatItem.name === format)
                      ?.subFormats.map((subFormat, index) => (
                        <option key={index} value={subFormat}>
                          {subFormat}
                        </option>
                      ))}
                    <option value="update-list" style={{ color: "#f79328", fontWeight: "bold" }}>
                      Update List
                    </option>
                  </select>
                </div>
              </div>

              <div className={Styles.createsession_form_containertwo}>
                <label className={Styles.label}>Rest Time</label>
                <div className={Styles.time_field}>
                  <span className={Styles.icon}>
                    <svg width="25" height="25" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.333 22C17.8559 22 22.333 17.5228 22.333 12C22.333 6.47715 17.8559 2 12.333 2C6.81016 2 2.33301 6.47715 2.33301 12C2.33301 17.5228 6.81016 22 12.333 22Z" stroke="#808080" stroke-width="1.5" />
                      <path d="M12.333 8V12L14.333 14" stroke="#808080" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <input
                    type="text"
                    placeholder="00"
                    className={Styles.time_input}
                    value={hours}
                    onChange={(e) => handleTimeFieldChange(e, "hours")}
                    onBlur={() => padTimeValue(hours, setHours)}
                  />
                  <span className={Styles.separator}>:</span>
                  <input
                    type="text"
                    placeholder="00"
                    className={Styles.time_input}
                    value={minutes}
                    onChange={(e) => handleTimeFieldChange(e, "minutes")}
                    onBlur={() => padTimeValue(minutes, setMinutes)}
                  />
                  <span className={Styles.separator}>:</span>
                  <input
                    type="text"
                    placeholder="00"
                    className={Styles.time_input}
                    value={seconds}
                    onChange={(e) => handleTimeFieldChange(e, "seconds")}
                    onBlur={() => padTimeValue(seconds, setSeconds)}
                  />
                </div>
              </div>
            </div>
            <div className={Styles.createsession_form_containerright}>
              <label className={Styles.label}>
                Enter Resting Period Details
              </label>
              <div className="second-quill">
                <ReactQuill
                  theme="snow"
                  placeholder="Enter here..."
                  className={Styles.customQuill}
                  value={restPeriodDetails}
                  onChange={handleRestPeriodDetailsChange}
                />
              </div>
            </div>
          </div>
          <div className={Styles.seperator}>
            <hr className={Styles.line} />
          </div>
          <div className={Styles.button_group}>
            <button
              className={Styles.save_button}
              onClick={handleSubmit}
              style={{ cursor: "pointer" }}
            >
              Next
            </button>
            <button
              className={Styles.cancel_button}
              onClick={handleBack}
              style={{ cursor: "pointer" }}
            >
              Cancel
            </button>
          </div>
        </div>

        {/* Edit List Modal for Formats */}
        {showEditModal && (
          <div className={Styles.update_list_modal_overlay}>
            <div className={Styles.update_list_modal}>
              <div className={Styles.modal_header}>
                <h3>EDIT LIST</h3>
              </div>
              <div className={Styles.modal_content}>
                <div className={Styles.list_items_container}>
                  {editableFormats.map((item, index) => (
                    <div key={item._id} className={Styles.edit_list_item}>
                      <input 
                        type="text" 
                        value={item.name} 
                        onChange={(e) => {
                          const newFormats = [...editableFormats];
                          newFormats[index].name = e.target.value;
                          setEditableFormats(newFormats);
                        }}
                        className={Styles.edit_input}
                      />
                    </div>
                  ))}
                </div>

                <div className={Styles.modal_footer}>
                  <button onClick={handleEditFormatSave} className={Styles.save_btn}>Save</button>
                  <button onClick={() => setShowEditModal(false)} className={Styles.cancel_btn_modal}>Cancel</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Edit List Modal for Sub-Formats */}
        {showEditSubModal && (
          <div className={Styles.update_list_modal_overlay}>
            <div className={Styles.update_list_modal}>
              <div className={Styles.modal_header}>
                <h3>EDIT SUB-FORMAT LIST</h3>
                <p style={{ color: "#aaa", fontSize: "0.8rem", marginTop: "5px" }}>Format: {format}</p>
              </div>
              <div className={Styles.modal_content}>
                <div className={Styles.list_items_container}>
                  {editableSubFormats.map((sub, index) => (
                    <div key={index} className={Styles.edit_list_item}>
                      <input 
                        type="text" 
                        value={sub} 
                        onChange={(e) => {
                          const newSubFormats = [...editableSubFormats];
                          newSubFormats[index] = e.target.value;
                          setEditableSubFormats(newSubFormats);
                        }}
                        className={Styles.edit_input}
                      />
                    </div>
                  ))}
                </div>

                <div className={Styles.modal_footer}>
                  <button onClick={handleEditSubFormatSave} className={Styles.save_btn}>Save</button>
                  <button onClick={() => setShowEditSubModal(false)} className={Styles.cancel_btn_modal}>Cancel</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default EditFormat;
